import React, { ReactNode } from 'react';
import styled from 'styled-components';
import StockAnalysisNavbar from './StockAnalysisNavbar';
import StockAnalysisFooter from './StockAnalysisFooter';

interface ProjectLayoutProps {
  children: ReactNode;
  transparentHeader?: boolean;
  hideFooter?: boolean;
}

const ProjectLayout: React.FC<ProjectLayoutProps> = ({
  children,
  transparentHeader = false,
  hideFooter = false,
}) => {
  return (
    <LayoutWrapper>
      <StockAnalysisNavbar transparent={transparentHeader} />
      <Main>{children}</Main>
      {!hideFooter && <StockAnalysisFooter />}
    </LayoutWrapper>
  );
};

const LayoutWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.background};
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
`;

export default ProjectLayout;
